import { styled, SxProps, Tooltip, tooltipClasses } from "@mui/material";

import { useLocalTimeTooltip } from "./useLocalTimeTooltip";

import type { ReactElement } from "react";

const TOOLTIP_MAX_WIDTH = 260;

interface LocalTimeTooltipProps {
  children: ReactElement;
  date: Date;
  sx?: SxProps;
  withSeconds?: boolean;
  underlineSpace?: boolean;
}

export function LocalTimeTooltip({
  date,
  children,
  sx,
  withSeconds = true,
  underlineSpace = false,
}: LocalTimeTooltipProps) {
  const { title } = useLocalTimeTooltip({ date, withSeconds });

  return (
    <UnderlinedTooltip
      placement="bottom"
      title={title}
      children={children}
      PopperProps={{
        disablePortal: true,
      }}
      sx={sx}
      arrow
    />
  );
}

const UnderlinedTooltip = styled(Tooltip)(() => ({
  cursor: "pointer",
  backgroundImage:
    "linear-gradient(to right, rgba(105, 111, 140, 1) 40%, rgba(105,111,140,0) 0%)",
  backgroundPosition: "bottom",
  backgroundSize: "5px 1px",
  backgroundRepeat: "repeat-x",

  [`+ .${tooltipClasses.popper}`]: {
    maxWidth: TOOLTIP_MAX_WIDTH,
  },
}));
